import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
  Alert
} from '@mui/material';
import { formatPrice } from '../utils/formatters';

interface Property {
  title: string;
  price: string;
  price_numeric: number;
  location: string;
  area: string;
  rooms: string;
  floor: string;
  age: string;
}

interface MahalleStats {
  count: number;
  average_price: number;
  properties: Property[];
}

const MahalleStats: React.FC = () => {
  const [stats, setStats] = useState<{ [key: string]: MahalleStats }>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL || 'https://evrim-api.vercel.app'}/properties/by-mahalle`);
        if (!response.ok) {
          throw new Error('Veriler alınamadı');
        }
        const data = await response.json();
        setStats(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>

      
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Mahalle</TableCell>
              <TableCell align="right">Ev Sayısı</TableCell>
              <TableCell align="right">Ortalama Fiyat</TableCell>
              <TableCell align="right">En Düşük Fiyat</TableCell>
              <TableCell align="right">En Yüksek Fiyat</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(stats).map(([mahalle, data]) => (
              <TableRow key={mahalle}>
                <TableCell component="th" scope="row">
                  {mahalle}
                </TableCell>
                <TableCell align="right">{data.count}</TableCell>
                <TableCell align="right">{formatPrice(data.average_price)}</TableCell>
                <TableCell align="right">
                  {formatPrice(data.properties[0]?.price_numeric || 0)}
                </TableCell>
                <TableCell align="right">
                  {formatPrice(data.properties[data.properties.length - 1]?.price_numeric || 0)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default MahalleStats; 